import type { ImageJob } from "../shared/creative-generation";

/**
 * The latest image result, kept to what the architect acts on: a thin
 * progress line while generating, the error if it failed, otherwise the image
 * and one placement action. Once placed it shrinks to a small row.
 */
export function ImageGenerationResult({
  job,
  add,
  placed = false,
  sourcePreview,
}: {
  job: ImageJob;
  add: (job: ImageJob) => void;
  placed?: boolean;
  sourcePreview?: string;
}) {
  const sketch = job.kind === "sketch";
  if (job.state === "running")
    return (
      <div
        className="creative-result creative-progress"
        role="status"
        aria-label={sketch ? "Creating image" : "Generating edit"}
      >
        <span />
      </div>
    );
  if (job.state !== "ready" || !job.output)
    return (
      <p className="creative-result creative-warning" role="status">
        {job.error || "Generation needs attention."}
      </p>
    );
  const src = `${job.output.src}?size=1024`;
  const label = sketch ? "Sketch image" : "Edited image";
  return (
    <figure
      className="creative-result"
      aria-label={label}
      data-placed={placed}
    >
      {sketch && sourcePreview && !placed ? (
        <div
          className="sketch-compare"
          aria-label="Sketch source and result comparison"
        >
          <img src={sourcePreview} alt="Original sketch preview" />
          <img src={src} alt="Generated sketch image preview" />
        </div>
      ) : (
        <img src={src} alt={`${label} preview`} title={job.prompt} />
      )}
      <figcaption>
        <small>{placed ? "On board · original kept" : "Original kept"}</small>
        <button
          type="button"
          className={placed ? "creative-text-button" : "primary"}
          onClick={() => add(job)}
        >
          {placed ? "Show on board" : "Add to board"}
        </button>
      </figcaption>
    </figure>
  );
}
